export const TREND_CELL_RENDERER = 'TREND_CELL_RENDERER';
export const KPI_NAME_RENDERER = 'KPI_NAME_RENDERER';
